import BasePaymentSelectCard from './BasePaymentSelectCard';
import NoOptions from './NoOptions';
import usePaymentSelect from './usePaymentSelect';

const PaymentSelect: React.FunctionComponent = function () {
  const { options } = usePaymentSelect();
  if (options.length === 0) return <NoOptions />;
  return (
    <div className="flex flex-col gap-y-4 mt-4 md:mt-0">
      {options.map((option) => (
        <BasePaymentSelectCard key={option} type={option} />
      ))}
    </div>
  );
};

export default PaymentSelect;
